import { AbstractType, Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { GridCellRenderer } from '../abstraction/grid-cell-renderer';

export interface ServerSideColumnOption {
  serverSideField: string;
  serverSideAlias?: string;
}

export interface ColumnOptionsBase <TRow extends object, TValue> {
  colId: string;
  header: Signal<Translation>;
  getValue: (row: TRow) => TValue,

  cellClass?: string;
  headerClass?: string;
  enableRowGroup?: boolean;
  hide?: boolean;
  cellRenderer?: AbstractType<GridCellRenderer<TRow, TValue>>
}
